import type { SystemStyleObject } from '@chakra-ui/react';
import { MENTION_CHIP_CLASS } from './mentionUtils';
import { MENTION_DRAFT_CLASS } from './mentionDom';

// Placeholder pseudo-element, in-progress draft color, and the mention chip
// pill for the contenteditable root.
export const mentionEditorSx: SystemStyleObject = {
  fontSize: '14px',
  lineHeight: '20px',
  color: 'secondary-900',
  '&[data-empty="true"]::before': {
    content: 'attr(data-placeholder)',
    color: 'secondary-400',
    pointerEvents: 'none',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: '5px',
  },
  [`& .${MENTION_DRAFT_CLASS}`]: {
    color: 'primary-500',
  },
  [`& .${MENTION_CHIP_CLASS}`]: {
    display: 'inline-block',
    padding: '0 6px',
    margin: '0 1px',
    borderRadius: '6px',
    backgroundColor: 'primary-50',
    color: 'primary-700',
    fontWeight: 500,
    userSelect: 'all',
    cursor: 'default',
    whiteSpace: 'nowrap',
    verticalAlign: 'baseline',
    lineHeight: '20px',
  },
};
